
import React from 'react';

const Step3_Installation = ({ formData, handleChange, nextStep, prevStep }) => {

  const renderRadioCard = (name, value, label) => (
    <label className={`block p-4 border rounded-lg cursor-pointer transition ${formData[name] === value ? 'bg-blue-50 border-blue-500 ring-2 ring-blue-500' : 'bg-white border-gray-300 hover:border-gray-400'}`}>
      <input 
        type="radio" 
        name={name} 
        value={value} 
        checked={formData[name] === value} 
        onChange={handleChange} 
        className="sr-only" 
      />
      <span className="font-bold text-gray-800">{label}</span>
    </label>
  );

  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-700 mb-6">Étape 3 : L'installation électrique</h2>
      <div className="space-y-6">

        <div>
          <label htmlFor="distanceToPanel" className="block text-sm font-medium text-gray-600 mb-1">Distance entre le tableau électrique et la borne (en mètres)</label>
          <input type="number" id="distanceToPanel" name="distanceToPanel" value={formData.distanceToPanel} onChange={handleChange} placeholder="Ex: 15" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" />
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-600 mb-2">Type de compteur électrique</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {renderRadioCard('meterType', 'Monophasé', 'Monophasé')}
            {renderRadioCard('meterType', 'Triphasé', 'Triphasé')}
          </div>
        </div>

        <div>
          <label htmlFor="meterPower" className="block text-sm font-medium text-gray-600 mb-1">Puissance de votre compteur actuel (kVA)</label>
          <input type="number" id="meterPower" name="meterPower" value={formData.meterPower} onChange={handleChange} placeholder="Ex: 9" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" />
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-600 mb-2">Besoin de travaux de voirie ?</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {renderRadioCard('roadworkNeeded', 'Non', 'Non')}
            {renderRadioCard('roadworkNeeded', 'Oui', 'Oui')}
          </div>
        </div>

      </div>

      <div className="mt-8 flex justify-between">
        <button type="button" onClick={prevStep} className="px-8 py-3 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition-colors">
          Précédent
        </button>
        <button type="button" onClick={nextStep} className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors">
          Suivant
        </button>
      </div>
    </div>
  );
};

export default Step3_Installation;
